import { useEffect, useState } from "react";

function CountryFormatter({ title }: { title: string }) {
  const [country, setCountry] = useState<string>();
  const [count, setCount] = useState<number | "">();
  const COUNTRY_FORMATTER_MAX_LENGTH = 35;

  useEffect(() => {
    if (title && title?.length > COUNTRY_FORMATTER_MAX_LENGTH) {
      const tempCountry = title
        ?.substring(0, COUNTRY_FORMATTER_MAX_LENGTH)
        ?.split(/[,&]/);
      if (tempCountry.length > 1) {
        tempCountry.pop();
      }

      setCountry(tempCountry?.join(", "));

      const tempCount =
        title && title?.split(/[,&]/).length - tempCountry.length;
      setCount(tempCount);
    } else {
      setCountry(title);
    }
  }, [title]);

  return (
    <>
      {country}
      {title && title?.length > COUNTRY_FORMATTER_MAX_LENGTH ? (
        <span
          style={{
            fontSize: 12,
            marginLeft: 0,
            color: "#9B9B9B",
          }}
        >
          {` ...  ${count && count > 0 ? `+${count} more` : ""}`}
        </span>
      ) : null}
    </>
  );
}

export default CountryFormatter;
